/**
 * The presentation creation application's own routes, mounted by the shell at /presentations.
 *
 * Nothing in here knows it sits at /presentations — the prefix is the shell's decision, recorded
 * once in `platform/registry.ts`.
 */
import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { DocumentFaceScope } from '@/theme/DocumentFaceScope';

const DecksPage = lazy(() => import('@/apps/presentations/DecksPage'));
const DeckNewPage = lazy(() => import('@/apps/presentations/DeckNewPage'));
const DeckDetailPage = lazy(() => import('@/apps/presentations/DeckDetailPage'));
const DeckEditPage = lazy(() => import('@/apps/presentations/DeckEditPage'));
const AddedSlidePage = lazy(() => import('@/apps/presentations/AddedSlidePage'));
const HtmlTemplatesPage = lazy(() => import('@/apps/presentations/HtmlTemplatesPage'));
const HtmlTemplateNewPage = lazy(() => import('@/apps/presentations/HtmlTemplateNewPage'));

export const presentationsRoutes = (
  <Route path="presentations" element={<DocumentFaceScope />}>
    <Route index element={<DecksPage />} />
    <Route path="decks/new" element={<DeckNewPage />} />
    <Route path="decks/:deckId" element={<DeckDetailPage />} />
    <Route path="decks/:deckId/edit" element={<DeckEditPage />} />
    <Route path="decks/:deckId/slides/new" element={<AddedSlidePage />} />
    <Route path="decks/:deckId/slides/:addedId" element={<AddedSlidePage />} />
    <Route path="html-templates" element={<HtmlTemplatesPage />} />
    <Route path="html-templates/new" element={<HtmlTemplateNewPage />} />
  </Route>
);
